// extracted by mini-css-extract-plugin
export default {"container":"ConfirmEmail_container__svK42","text":"ConfirmEmail_text__rlymJ","textCentered":"ConfirmEmail_textCentered__700tL","buttonConfirm":"ConfirmEmail_buttonConfirm__7mRGd"};